import React from 'react';
import { dataModelerSetSchemaDisabled } from '../../../../redux/slices/dataModeler';
import SwitchiOS from '../../../../components/SwitchiOS';
import { useAppDispatch } from '../../../../redux/hooks';
import styled from 'styled-components';
import { dataModelLabelInfoTooltipOptions } from '../../../../components/KubitTooltip/globalTooltips';
import { theme } from '../../../../styles/theme';
import InformationalTooltip from '../../../../components/InformationalTooltip';
import { useDataModelerContext } from '../../DataModelerContext';
import useCustomerPlan from '../../../../utils/hooks/useCustomerPlan';

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;
const Label = styled.div`
  color: ${theme.colors.secondary900};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
`;

const SchemaEnableDisable = () => {
  const dispatch = useAppDispatch();
  const { draftEdits, schemaObj, isEditMode } = useDataModelerContext();
  const { maxSchemas } = useCustomerPlan();
  const isDisabled = draftEdits?.disabled ?? schemaObj?.disabled ?? false;
  const setDisabled = (disabled: boolean) => {
    if (maxSchemas && maxSchemas?.availableSchemas === 0 && isDisabled) {
      return;
    }
    if (!isEditMode) {
      return;
    }
    dispatch(dataModelerSetSchemaDisabled({ disabled }));
  };

  const maxSchemaTooltip =
    maxSchemas && maxSchemas?.availableSchemas <= 0 && isDisabled
      ? dataModelLabelInfoTooltipOptions.maxSchemasReached.content(
          maxSchemas?.maxSchemas,
        )
      : '';

  const tooltipOption = maxSchemaTooltip
    ? { content: maxSchemaTooltip }
    : dataModelLabelInfoTooltipOptions.schemaEnabled;

  return (
    <Container>
      <Wrapper>
        <SwitchiOS
          isChecked={!isDisabled}
          onClick={() => setDisabled(!isDisabled)}
        />
        <Label>Enabled</Label>
        <InformationalTooltip
          tooltipOption={tooltipOption}
          placement="top-end"
        />
      </Wrapper>
    </Container>
  );
};

export default SchemaEnableDisable;
